import React, { useState } from 'react';
import { Datagrid, List, TextField, translate } from 'admin-on-rest';
import get from 'lodash/get';
import { Card, CardActions, CardText, CardTitle } from 'material-ui';
import CircularProgress from 'material-ui/CircularProgress/CircularProgress';
import DeleteButton from '../../components/button/DeleteButton';
import EditButton from '../../components/button/EditButton';
import { useGetRows } from './hooks/useGetRows';
import { Sheet } from './Sheet';
import { SubmitButton } from './SubmitButton';
import { API_BASE_URL } from '../../App';
import { isSuperUser } from '../../utils/permissionsUtils';


export const AccountingPlanV2List = (props) => (
  <List
    {...props}
    perPage={9999}
    filter={
      isSuperUser(props.user)
        ? null
        : {
          venue: { $in: props.user.venues },
        }
    }
  >
    <Datagrid>
      <TextField source="publicName" />
      <EditButton {...props} basePath="/accounting-plans-v2" />
      <DeleteButton {...props} basePath="/accounting-plans-v2" />
    </Datagrid>
  </List>
);


function Edit({ translate: t, match }) {
  const id = get(match, 'params.id');
  const { rows, loading, error, resetError } = useGetRows(id);
  const [updatedPlan, setUpdatedPlan] = useState();

  let children = [
    <h3>{t('resources.accounting-plans.headers.incoming')}</h3>,
    <Sheet
      className="incoming"
      t={t}
      rows={rows}
      filter={(row) => row.type === 'incoming'}
      value={updatedPlan}
      onChange={(value) => {
        setUpdatedPlan(value);
        resetError();
      }}
    />,
    <h3>{t('resources.accounting-plans.headers.outgoing')}</h3>,
    <Sheet
      className="outgoing"
      t={t}
      rows={rows}
      filter={(row) => row.type === 'outgoing'}
      value={updatedPlan}
      onChange={(value) => {
        setUpdatedPlan(value);
        resetError();
      }}
    />,
  ];

  if (loading) {
    children = <CircularProgress />;
  }
  if (error) {
    children = (
      <p style={{ color: 'red' }}>
        {t('errors.fetch-failed')} {error.status || 500}: {error.message || error.error}
      </p>
    );
  }

  return (
    <Card>
      <CardText>
        <CardTitle>
          <h2>{id} plan</h2>
        </CardTitle>
        {children}
      </CardText>
      <CardActions>
        <SubmitButton
          disabled={loading || error}
          url={`${API_BASE_URL}/accounting-plans-v2/${id}`}
          body={updatedPlan}
          t={t}
        >
          {t('save')}
        </SubmitButton>
      </CardActions>
    </Card>
  );
}

export const AccountingPlanV2Edit = translate(Edit);
